import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { StyledDivider, StyledTooltipContent } from './style';
import { IProductResponse } from 'utils/types';
import { TooltipSection } from '../types';
import { CSSObject } from 'styled-components';

interface IExtendedTooltipTitleProps {
  titleImg: string;
  title: string;
  sections: TooltipSection[];
  mapProductSrc: Record<string, string>;
  headersColorCss?: CSSObject;
  dividerColor?: string;
}

export const ExtendedTooltipTitle: React.FC<IExtendedTooltipTitleProps> = ({
  titleImg,
  title,
  sections,
  mapProductSrc,
  headersColorCss = {},
  dividerColor,
}) => {
  return (
    <StyledTooltipContent headersColorCss={headersColorCss}>
      <div className={'heading'}>
        {titleImg && (
          <div className={'heading--image-container'}>
            <img
              className={'heading--image-container__img'}
              src={titleImg}
              alt={'img'}
            />
          </div>
        )}
        {title && <Typography className={'heading--text'}>{title}</Typography>}
      </div>
      {sections.map(({ sectionName, products }) => (
        <div className={'section'}>
          <StyledDivider className="divider" color={dividerColor} />
          {sectionName && (
            <Typography className={'section--name'}>{sectionName}</Typography>
          )}
          <ul className={'section--list'}>
            {products.map(({ publisherProductId, text }, i) => (
              <li key={i} className={'section--list__item'}>
                {mapProductSrc[publisherProductId] && (
                  <div className={'item--image-container'}>
                    <img
                      src={mapProductSrc[publisherProductId]}
                      alt={'coin'}
                      className={'item--image-container__img'}
                    />
                  </div>
                )}
                <Typography className={'item--text'}>{text}</Typography>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </StyledTooltipContent>
  );
};
